import {
  Button, Stack, styled, Typography,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { InfoOutlined } from '@mui/icons-material';
import useToggle from '../../../hooks/useToggle';
import { ConfirmDialogBox } from '../../../components/CustomDialogBox';
import { CustomIcon } from '../../../components/CustomIcon';
import ModifyLevels from './ModifyLevels';
import { parseComposedId } from '../utils/helpers';

const ChipButton = styled(Button)(({ theme, variant }) => ({
  cursor: 'initial',
  ':hover': {
    color: variant === 'outlined' ? theme.palette.primary.text : 'white',
    background: variant === 'outlined' ? 'transparent' : theme.palette.primary.main,
    borderColor: variant === 'outlined' ? theme.palette.primary.border : 'none',
  },
}));

function TaxonomyLevels({
  levels, setLevels, treeData, setDirty, selectedNodeId,
}) {
  const { level: selectedLevel } = parseComposedId(selectedNodeId);
  const [modify, setModify] = useToggle(false);
  const [open, setOpen] = useToggle(false);

  return (
    <Stack width="100%" gap={4}>
      <Stack
        width="100%"
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Stack direction={{ xs: 'column', lg: 'row' }} gap={1}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="h6">Levels</Typography>
            <CustomIcon size="small" Icon={InfoOutlined} onClick={setOpen} />
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
            {levels?.map((level) => (
              <Stack
                key={level.level}
                direction="row"
                alignItems="center"
                spacing={1}
              >
                <ChipButton
                  variant={level.level === selectedLevel ? 'contained' : 'outlined'}
                  size="small"
                >
                  {level.name}
                </ChipButton>

                {/* Chevron */}
                <ChevronRightIcon
                  fontSize="small"
                  color="action"
                  sx={{
                    transform: { xs: 'rotate(90deg)', sm: 'none' },
                  }}
                />
              </Stack>
            ))}

            {/* Features line – render separately to break to new line */}
            <Stack direction="row" alignItems="center" spacing={1}>
              <ChipButton
                variant={selectedLevel === 0 ? 'contained' : 'outlined'}
                size="small"
              >
                Features
              </ChipButton>
            </Stack>
          </Stack>
        </Stack>

        <Button variant="outlined" size="small" onClick={setModify}>
          Modify Levels
        </Button>
      </Stack>

      {modify && (
      <ModifyLevels
        levels={levels}
        setLevels={setLevels}
        treeData={treeData}
        setDirty={setDirty}
        setModify={setModify}
      />
      )}

      <ConfirmDialogBox
        openDialog={open}
        title="Taxonomy Levels"
        message='Set up levels such as "Product," "Module" "Sub-module" to guide how your tree is structured. Add more levels for deeper categorization and better analytical clarity.'
        onClose={setOpen}
        cancelText="OK"
      />
    </Stack>
  );
}

export default TaxonomyLevels;
